import { makeStyles } from "components/mui-core";

export const DRAWER_WIDTH = 88; // TODO change back to 80 when remove "Recommender" from menu

const TEXT_COLORS = {
  default: "#BFC8CB",
  hover: "#FFFFFF",
  active: "#84D2E5",
};
const ROUTES_MENU_BG_COLORS = {
  default: "transparent",
  hover: "rgba(255, 255, 255, 0.30)",
  active: "rgba(132, 210, 229, 0.30)",
};

const USER_MENU_COLOR_BG = {
  default: "transparent",
  hover: "rgba(255, 255, 255, 0.10)",
  clicked: "rgba(255, 255, 255, 0.20);",
};

const darkMenu = {
  padding: 0,
  marginLeft: "60px",
  backgroundColor: "#021927",
};

export const useNavMenuStyles = makeStyles()({
  root: {
    paddingTop: "16px",
    paddingBottom: "24px",
    width: DRAWER_WIDTH,
    background: "#021927",
    height: "100vh",
    position: "relative",
    overflow: "hidden",
    flexShrink: 0,
  },
  blueOvalBg: {
    width: "240px",
    height: "272px",
    borderRadius: "272px",
    opacity: "0.7",
    background: "#84D2E5",
    filter: "blur(50px)",
    position: "absolute",
    bottom: "-65px",
    left: "-200px",
    zIndex: 0,
  },
  flexMenusContainer: {
    width: "100%",
    height: "100%",
    padding: 0,
    position: "relative",
    overflowX: "hidden",
    overflowY: "auto",
    // Use thin scrollbar that doesn't take up layout space
    scrollbarWidth: "thin",
    scrollbarColor: "rgba(255, 255, 255, 0.3) transparent",
    "&::-webkit-scrollbar": {
      width: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "rgba(255, 255, 255, 0.3)",
      borderRadius: "3px",
      "&:hover": {
        background: "rgba(255, 255, 255, 0.5)",
      },
    },
  },
});

export const useRouteMenuStyles = makeStyles<{ selected: boolean }, "icon">()(
  (_theme, { selected }, classes) => ({
    li: {
      padding: "4px 0",
      "& a": {
        textDecoration: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "8px",
        color: "none",
      },
    },
    menuItem: {
      transition: "all 300ms linear",
      padding: 0,
      margin: 0,
      width: "100%",
      maxWidth: "100%",
      listStyleType: "none",
      color: selected ? TEXT_COLORS.active : TEXT_COLORS.default,
      "& svg": {
        fill: selected ? TEXT_COLORS.active : TEXT_COLORS.default,
      },
      [`& .${classes.icon}`]: {
        backgroundColor: "none",
      },
      // Ensure text wraps and doesn't overflow
      "& .MuiListItemText-root": {
        textAlign: "center",
        margin: 0,
      },
      "&:hover": {
        color: TEXT_COLORS.hover,
        "& svg": {
          fill: TEXT_COLORS.hover,
        },
        [`& .${classes.icon}`]: {
          backgroundColor: ROUTES_MENU_BG_COLORS.hover,
        },
      },
    },
    icon: {
      transition: "all 300ms linear",
      backgroundColor: selected
        ? ROUTES_MENU_BG_COLORS.active
        : ROUTES_MENU_BG_COLORS.default,
      borderRadius: "16px",
      padding: "4px 0",
      width: "56px",
      height: "32px",
    },
  })
);

export const useInfoMenuStyles = makeStyles<
  void,
  "infoItemBg" | "infoItemActive"
>()((_theme, _params, classes) => ({
  infoItem: {
    width: "40px",
    height: "40px",
    cursor: "pointer",
    justifyContent: "center",
    paddingTop: 0,
    paddingBottom: 0,
    "& svg": {
      fill: TEXT_COLORS.default,
    },
    "&:hover": {
      "& svg": {
        fill: TEXT_COLORS.hover,
      },
      [`& .${classes.infoItemBg}`]: {
        backgroundColor: ROUTES_MENU_BG_COLORS.hover,
      },
    },
    [`&.${classes.infoItemActive}`]: {
      "& svg": {
        fill: "#A7EDFF",
      },
      [`& .${classes.infoItemBg}`]: {
        backgroundColor: "rgba(167, 237, 255, 0.30)",
      },
    },
  },
  infoItemActive: {},
  infoItemBg: {
    transition: "all 300ms linear",
    width: "40px",
    height: "40px",
    minWidth: "40px",
    borderRadius: "8px",
    // Ensure child elements fill 100% so click on any part of background will trigger the action
    "& > *": {
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
  darkMenu: {
    ...darkMenu,
    padding: "0 10px",
    maxHeight: "420px",
    marginLeft: "70px",
  },
}));

export const useCurrentUserMenuStyles = makeStyles()({
  link: {
    textDecoration: "none",
    color: "inherit",
  },
  darkMenu: {
    ...darkMenu,
    color: TEXT_COLORS.default,
    "& svg": {
      fill: TEXT_COLORS.default,
    },
  },
  listItemReadonly: {
    height: "56px",
    width: "100%",
    cursor: "default",
  },
  listItem: {
    height: "56px",
    width: "100%",
    "& .MuiTouchRipple-child": {
      backgroundColor: USER_MENU_COLOR_BG.clicked,
    },
    transition: "all 300ms linear",
    "&:hover": {
      backgroundColor: USER_MENU_COLOR_BG.hover,
      cursor: "pointer",
      color: TEXT_COLORS.hover,
      "& svg": {
        fill: TEXT_COLORS.hover,
      },
    },
  },
  divider: {
    borderColor: "#CAC4D0",
    margin: "8px 0",
  },
});
